angular.module('picmonic-common').factory('FreePremiumTrialModal', [
  '$modal',
  '$cookies',
  'UserService',
  'SplitTestService',
  function ($modal, $cookies, UserService, SplitTestService) {
    return {
      show: function () {
        $modal.open({
          windowClass: 'pls-modal-platinum premium-trial-modal free-premium-trial-modal-new',
          size: 'md',
          backdropClass: 'bd-opaque',
          templateUrl: '/templates/modals/premium_trial_new.html',
          controller: [
            '$scope',
            '$interval',
            '$timeout',
            'MarketOptionsConfig',
            function ($scope, $interval, $timeout, MarketOptionsConfig) {
              $scope.UserService = UserService;
              $scope.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
              $scope.end = parseInt(UserService.user.created_at + 60 * 60 * 24);
              $scope.now = parseInt(Date.now() / 1000, 10);

              $scope.timeLeft = $scope.end - $scope.now;
              $scope.activeDotIndex = 1;

              $timeout(function () {
                angular.element('.blocks-container').on('scroll', function () {
                  element = angular.element('.blocks-container');

                  $scope.$apply(function () {
                    $scope.activeDotIndex = element.scrollLeft() ? 0 : 1;
                  });
                });
              });

              $scope.scrollTo = function (element) {
                angular.element(element)[0].scrollIntoView({
                  alignToTop: false,
                  block: 'end',
                  behavior: 'smooth',
                });
              };

              $scope.interval = $interval(function () {
                $scope.timeLeft--;

                if ($scope.timeLeft <= 0) {
                  $interval.cancel($scope.interval);
                  $cookies.remove('pls_user_premium_trial_eligible');
                  $scope.$close();
                }
              }, 1000);

              $scope.$on('$destroy', function () {
                if ($scope.interval) {
                  $interval.cancel($scope.interval);
                }
              });

              $scope.hours = function (asPercent) {
                var hours = Math.floor($scope.timeLeft / (60 * 60)) % 24;

                if (asPercent) {
                  return parseInt((hours / 24) * 100, 10);
                }

                if (hours < 10) {
                  hours = '0' + hours;
                }
                return hours;
              };

              $scope.minutes = function (asPercent) {
                var minutes = Math.floor($scope.timeLeft / 60) % 60;

                if (asPercent) {
                  return parseInt((minutes / 60) * 100, 10);
                }

                if (minutes < 10) {
                  minutes = '0' + minutes;
                }
                return minutes;
              };

              $scope.seconds = function (asPercent) {
                var seconds = Math.floor($scope.timeLeft) % 60;

                if (asPercent) {
                  return parseInt((seconds / 60) * 100, 10);
                }

                if (seconds < 10) {
                  seconds = '0' + seconds;
                }
                return seconds;
              };

              $scope.tryPremiumFree = function () {
                $scope.$close();
              };

              $scope.continueLimited = function () {
                $scope.$close();
              };
            },
          ],
        });
      },
    };
  },
]);
